import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import Api from "services/api"


export const initialState = {
  appointmentDetails: [],
  error: null,
  loader: false,
  featured: {},
  total: 0,
  is_more: false,
  last_page: 1,
  current_page: 1,
  popup: {
    show: false,
    item: {}
  }
}

export const appointmentDetailsSlice = createSlice({
  name: 'appointmentDetails',
  initialState: initialState,
  reducers: {
    setAppointmentDetails: (state, { payload }) => {
      state.appointmentDetails = payload ?? payload;
    },
    setAppointmentDetails: (state, { payload }) => {
      state.appointmentDetails = payload;
    },
    rejectAppointmentDetails: (state, { payload }) => {
      state.error = payload
    },
    setError: (state, { payload }) => {
      state.error = payload
    },
    setLoader: (state, { payload }) => {
      state.loader = payload
    },
  }
})

export const acceptAppointmentDetails = (token, callback) => async (dispatch) => {
  const apiService = new Api();
  dispatch(setError({}))
  dispatch(setLoader(true))
  try {
    const json = await Api.acceptAppointmentDetails(token)
    if (json.status >= 200 && json.status < 300) {
      callback(true, json.data.message)
    } else {
      dispatch(setError(json.data))
      callback(false, json.data.message)
    }
  } catch (error) {
    console.log(error)
  }
  dispatch(setLoader(false))
}

export const rejectAppointmentDetails = (token, callback) => async (dispatch) => {
  const apiService = new Api();
  dispatch(setError({}))
  dispatch(setLoader(true))
  try {

    const json = await Api.rejectAppointmentDetails(token)
    if (json.status >= 200 && json.status < 300) {
      callback(true, json.data.message)
    } else {
      dispatch(setError(json.data))
      callback(false, json.data.message)
    }
  } catch (error) {
    console.log(error)

  }
  dispatch(setLoader(false))
}

export const fetchAppointmentDetails = (token ,callback) => async (dispatch) => {
  const apiService = new Api();
  dispatch(setLoader(true))
  try {
    const result = await Api.fetchAppointmentDetails(token)
    
    if (result.status >= 200 && result.status < 300) {
        dispatch(setAppointmentDetails(result.data.data));
        callback(true, result.data.message)
    }
    else {
      dispatch(setError(result.data))
      callback(false, result.data.message)
    }
  } catch (error) {
    console.log("error", error)
  }
  dispatch(setLoader(false))
}


export const { 
  setAppointmentDetails, setLoader, 
  setError

} = appointmentDetailsSlice.actions


export default appointmentDetailsSlice.reducer
export const appointmentDetailsSelector = state => state.appointmentDetails


